// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width:992px) {
    .values-banner{
        padding-left: 132px;
        padding-right: 132px;

    }
}
@media(min-width:768px) and (max-width:991px) {
    .values-banner{
        padding-left: 24px;
        padding-right: 24px;

    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/about/components/ValuesBanner.css"],"names":[],"mappings":"AAAA;IACI;QACI,mBAAmB;QACnB,oBAAoB;;IAExB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,mBAAmB;;IAEvB;AACJ","sourcesContent":["@media(min-width:992px) {\n    .values-banner{\n        padding-left: 132px;\n        padding-right: 132px;\n\n    }\n}\n@media(min-width:768px) and (max-width:991px) {\n    .values-banner{\n        padding-left: 24px;\n        padding-right: 24px;\n\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
